

















































import Vue from 'vue'
import { messageFeedCSVExport } from '@/utility/helpers'
import DateTimeSelector from '@/components/DateTimeSelector.vue'
import MenuSelector from '@/components/MenuSelector.vue'
import StartAndEndDateSelection from '@/components/StartAndEndDateSelection.vue'
import TooltipActions from '@/components/TooltipActions.vue'
export default Vue.extend({
    name: 'DataTableHeader',
    components: { DateTimeSelector, MenuSelector, TooltipActions },
    props: {
        menuSelectors: {
            type: Array,
            required: false
        },
        searchValue: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            // Export options which we use for our export messages button
            exportOptions: [
                {
                    title: 'Export Entire Message History',
                    icon: 'mdi-all-inclusive'
                },
                {
                    title: 'Export Just Messages In Filter',
                    icon: 'mdi-filter'
                }
            ],

            // Default filter option that is automatically chosen
            initialDate: 'All Time',

            // The v-model for the text field
            search: null,

            // Start and end dates used to filter messages, start date is modified later on
            startDate: null,
            endDate: null,

            // The refresh tooltip action
            tooltipAction: [
                {
                    callback: () => this.$emit('refresh'),
                    icon: 'mdi-refresh',
                    tooltip: 'Refresh'
                }
            ],

            // Choices user is allowed to make in the v-select
            timeSelector: [
                'All Time',
                'Last 30 Days',
                'Last 14 Days',
                'Last 7 Days',
                'Last 24 Hours',
                'Custom Time Length'
            ]
        }
    },
    mounted() {
        //  If we have a search value, then set search to searchValue
        this.searchValue && (this.search = this.searchValue)

        // We set our start and end dates to whatever is currently in our store when the messages feed page is loaded (30 days as of right now)
        this.startDate = this.$store.getters.messagesTableStartDate
        this.endDate = this.$store.getters.messagesTableEndDate
    },
    computed: {
        // Returns our messagestable.ts payload object which we use to paginate our filters
        payload(): object {
            return this.$store.getters.messagesTableParams
        }
    },
    methods: {
        // Calls messageFeedCSVExport from helpers.ts and enables user to export the sms_messages table
        onExportCSV(index: number): void {
            if (index === 0) {
                // Export messages with no filters
                messageFeedCSVExport(true)
            } else {
                // Export messages with filters
                messageFeedCSVExport(false)
            }
        },
        paginateChanges() {
            // Assemble payload to send to our store
            this.payload.endDate = this.endDate
            this.payload.startDate = this.startDate

            // We always set the page back to 1 when date filter is applied to prevent 2-1 page error
            this.payload.messagesCurrentPage = 1
            this.payload.page = 1

            //  Update the params in the store
            this.$store.commit('messagesTableParamsSet', this.payload)

            //  The filter has changed, so paginate the new filter
            this.$store.dispatch('messagesTableMessagesPaginate')
        },
        setDateTime(dateTime: string): void {
            switch (dateTime) {
                case 'All Time':
                    // Get the earliest time a computer fetches as it covers any message a tenant could've ever sent or recieved
                    this.startDate = new Date(null).toISOString()

                    // Get the current date and set that as the end date
                    this.endDate = new Date().toISOString()

                    break
                case 'Last 30 Days':
                    // Dock 30 days to get our start date
                    this.startDate = new Date().setDate(new Date().getDate() - 30)

                    // Needed to convert miliseconds of time given into an actual date we recognize
                    this.startDate = new Date(this.startDate).toISOString()
                    this.endDate = new Date().toISOString()

                    break
                case 'Last 14 Days':
                    // Dock 14 days to get our start date
                    this.startDate = new Date().setDate(new Date().getDate() - 14)

                    // Needed to convert miliseconds of time given into an actual date we recognize
                    this.startDate = new Date(this.startDate).toISOString()
                    this.endDate = new Date().toISOString()

                    break
                case 'Last 7 Days':
                    // Dock 7 days to get our start date
                    this.startDate = new Date().setDate(new Date().getDate() - 7)

                    // Needed to convert miliseconds of time given into an actual date we recognize
                    this.startDate = new Date(this.startDate).toISOString()
                    this.endDate = new Date().toISOString()

                    break
                case 'Last 24 Hours':
                    // Dock 24 hours to get our start date
                    this.startDate = new Date().setDate(new Date().getDate() - 1)

                    // Needed to convert miliseconds of time given into an actual date we recognize
                    this.startDate = new Date(this.startDate).toISOString()
                    this.endDate = new Date().toISOString()

                    break
                case 'Custom Time Length':
                    this.startDateSelection()

                    // We return instead of break here becuase we must paginate the changes in the StartEndDateSelection component
                    return
                default:
                    return
            }

            // Take anyone of the date filter changes the user applied and send it to our api to paginate (Besides custom time length)
            this.paginateChanges()
        },
        // Enables the user to make a custom start date selection that cannot go any earlier than when the tenant was made
        startDateSelection(): void {
            // Becuase we pass our start date to the calender it sets the initial selction at that date now that we have an all time
            // option it means the calender gets set to 1970 which we don't want so we change it if the user came from the all time option
            if (this.startDate.includes('1970')) {
                // Get the date the tenant was made to prevent confusion from seeing the calender say 1970
                this.payload.startDate = this.$store.getters.tenant.created_at

                //  Update the params in the store
                this.$store.commit('messagesTableParamsSet', this.payload)
            }

            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: 'Choose a Start and End Date',
                component: StartAndEndDateSelection,
                closeable: true
            })
        }
    }
})
